<div class="modalContainer">
  <div (click)="closeModal()" class="close-button">
    <svg
      class="closeIcon"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5784 19.3221C15.25 20.156 13.6844 20.6441 11.9968 20.6441C9.61111 20.6441 7.4491 19.6746 5.8835 18.1085C4.3179 16.5424 3.3555 14.3865 3.34872 11.9933C3.34872 10.3052 3.8367 8.73913 4.67033 7.41033C5.11086 6.80695 4.98209 5.9595 4.3789 5.51883L3.59271 6.59C2.58964 8.14931 2 10.0069 2 12.0001C2 17.5255 6.47314 22 11.9968 22C13.9894 22 15.8464 21.4102 17.4052 20.4C17.9881 19.9526 18.1101 19.1119 17.6695 18.5221L16.5784 19.3221Z"
        fill="#2D6DF6"
      />
      <path
        d="M21.9932 11.9999C21.9932 6.47453 17.5201 2 11.9965 2C9.93611 2 8.01808 2.6305 6.42538 3.70168C5.84929 4.16269 5.74763 4.99658 6.19494 5.5864L7.27256 4.76607C8.63484 3.87795 10.2479 3.35592 11.9965 3.35592C14.3821 3.35592 16.5442 4.3254 18.1098 5.89148C19.6754 7.45757 20.6378 9.61348 20.6445 12.0067C20.6445 13.7558 20.1227 15.3761 19.2348 16.732C18.7807 17.3286 18.8959 18.1761 19.4924 18.6303L20.2989 17.5795C21.3697 15.9863 22 14.0677 22 12.0067L21.9932 11.9999Z"
        fill="#2D6DF6"
      />
      <path
        d="M8.30279 14.5966L7.34717 15.5525C7.86226 16.0678 8.68233 16.0814 9.21098 15.6L11.8542 12.9627L14.4974 15.6068L15.4056 16.5152C15.9207 16 15.9071 15.1525 15.4259 14.617L12.8166 12L15.4124 9.40346L16.368 8.44753C15.8529 7.93229 15.0328 7.91873 14.5042 8.40008L11.861 11.0373L9.21775 8.3933L8.30957 7.48483C7.79448 8.00008 7.80804 8.84753 8.28924 9.38312L10.8986 12L8.30279 14.5966Z"
        fill="#2D6DF6"
      />
    </svg>
  </div>
  <div class="modal-header titleContainer">
    <h5 class="modal-title terminos-y-condiciones">Términos y Condiciones</h5>
  </div>
  <div class="modal-body texto-terminosYCond">
    Suramericana Tech S.A.S., en adelante SURA TECH, identificada con NIT.
    901641720-3, es una compañía colombiana de servicios, con la capacidad
    técnica, financiera y administrativa para operar tecnologías orientadas a
    habilitar la comercialización y posicionamiento de accesos y canales
    digitales para la industria financiera.<br /><br />
    SURA TECH no es una aseguradora, ni un corredor de seguros. SURA TECH es una
    compañía de tecnología que habilita la colocación de seguros digitales de
    las siguientes ASEGURADORAS:<br />
    - Seguros Sura S.A de C.V. – México.<br />
    - Seguros Sura S.A. - El Salvador.<br />
    - Seguros Sura S.A., Seguros de Personas – El Salvador.<br />
    - Seguros Sura S.A. - República Dominicana.<br />
    - Seguros Suramericana S.A. – Panamá.<br />
    - Seguros Generales Suramericana S.A. – Colombia.<br />
    - Seguros de Vida Suramericana S.A. – Colombia.<br />
    - Seguros Sura S.A. – Brasil.<br />
    - Seguros Generales Suramericana S.A. – Chile.<br />
    - Seguros de Vida Suramericana S.A. – Chile.<br />
    - Seguros Sura S.A. – Uruguay.<br />
    - Seguros Sura S.A. - Argentina.<br /><br />

    En ese sentido, la relación del contrato de seguro que se genera por el uso
    de esta página web es con la ASEGURADORA directamente y no con SURA TECH.<br /><br />

    SURA TECH presta los servicios y habilita la tecnología para colocar los
    productos de seguros de las ASEGURADORAS antes señaladas, lo que implica que
    se está utilizando el canal directo digital de las ASEGURADORAS y que SURA
    TECH no es un intermediario, sino un mero habilitador y prestador de
    servicios de tecnología.<br /><br />

    <strong>Definiciones</strong><br />
    ASEGURADORA(S): hace referencia a cualquier compañía o conjunto de compañías
    aseguradoras a las que SURA TECH presta los servicios y habilita la
    tecnología para colocar sus productos:<br /><br />
    - Seguros Sura S.A de C.V. – México.<br />
    - Seguros Sura S.A. - El Salvador.<br />
    - Seguros Sura S.A., Seguros de Personas – El Salvador.<br />
    - Seguros Sura S.A. - República Dominicana.<br />
    - Seguros Suramericana S.A. – Panamá.<br />
    - Seguros Generales Suramericana S.A. – Colombia.<br />
    - Seguros de Vida Suramericana S.A. – Colombia.<br />
    - Seguros Sura S.A. – Brasil.<br />
    - Seguros Generales Suramericana S.A. – Chile.<br />
    - Seguros de Vida Suramericana S.A. – Chile.<br />
    - Seguros Sura S.A. – Uruguay.<br />
    - Seguros Sura S.A. - Argentina.<br /><br />

    <u>T&C</u>: hace referencia a los presentes Términos y Condiciones en los
    que se regulan y describen los servicios prestados y ofrecidos por SURA TECH
    al USUARIO.<br />
    <u>USUARIO(S)</u>: hace referencia a cualquier persona natural o jurídica
    que haga uso de los servicios ofrecidos por SURA TECH o haya tenido o tenga
    acceso parcial o total a los servicios que SURA TECH pone a disposición.<br /><br />

    <strong>Aceptación</strong><br />
    Al usar esta página web, el USUARIO acepta que entiende y está de acuerdo
    con las condiciones establecidas en los T&C, en la Política de privacidad y
    Tratamiento de datos personales . de la ASEGURADORA, así como en los demás
    documentos incorporados a los mismos por referencia, y da el respectivo
    consentimiento expreso acerca de su compresión y aprobación por el uso del
    sitio web.<br /><br />

    <strong>Modificaciones</strong><br />
    SURA TECH podrá modificar estos T&C en cualquier momento haciendo públicos
    en esta página web los T&C modificados. Todos los T&C modificados entrarán
    en vigor a los 5 (cinco) días de su publicación. Todo usuario que no esté de
    acuerdo con las modificaciones efectuadas por SURA TECH deberá abstenerse de
    hacer uso de la página web, pues el uso de la página web y/o sus servicios
    implica la aceptación de estos T&C de uso del sitio web.<br /><br />

    <strong>Política de manejo de datos personales</strong> <br />
    SURA TECH será la encargada del tratamiento de los datos personales del
    USUARIO. Cada ASEGURADORA con la que se contrate el seguro será responsable
    del tratamiento de los datos personales y en ese sentido, será responsable
    del uso de la información para la finalidad que señale en su respectiva
    autorización de manejo de datos personales.<br /><br />

    El USUARIO podrá consultar las Políticas de privacidad y Tratamiento de
    Datos Personales de la ASEGURADORA con la que desea contratar o haya
    contratado un seguro mediante la página web de la ASEGURADORA
    correspondiente. Con el fin de facilitar la consulta de dichas políticas, se
    pone en conocimiento del USUARIO la página web de las ASEGURADORAS en donde
    podrá consultar dichas políticas:<br />
    - México: https://www.segurossura.com.mx/legales/aviso-de-privacidad/<br />
    - El Salvador: https://www.asesuisa.com/politica-privacidad<br />
    - República Dominicana:
    https://www.segurossura.com.do/politicas-seguridad-informacion/<br />
    - Panamá:
    https://segurossura.com.pa/wp-content/uploads/2022/04/politica-privacidad-y-tratamiento-de-datos-personales-seguros-sura-panama.pdf<br />
    - Colombia:
    https://www.segurossura.com.co/paginas/legal/politica-privacidad-datos.aspx<br />
    - Brasil: https://www.segurossura.com.br/politica-privacidade<br />
    - Chile<br />
    - Uruguay<br />
    - Argentina:
    https://www.segurossura.com.ar/politicas-de-proteccion-de-datos-personales/<br /><br />

    Cada ASEGURADORA obtendrá el consentimiento de los titulares previo a
    consignar cualquier dato personal en sus bases de datos. La ASEGURADORA
    deberá comunicarle al titular de forma clara y oportuna, el propósito de uso
    de sus datos personales, así como los derechos que le asisten como titular
    de estos.<br /><br />

    <strong>Servicios</strong> <br />
    Los servicios prestados por SURA TECH consisten en la habilitación de una
    plataforma tecnológica que le permite al USUARIO realizar gestiones
    relativas la consulta, gestión, cotización, compra, pago, modificación,
    solicitud de asistencia, reclamación, renovación, cancelación, asesoría o
    resolución de dudas relativas a los productos digitales de seguros de las
    ASEGURADORAS.<br />

    Los servicios que SURA TECH ofrece se hacen única y exclusivamente para uso
    personal y no comercial. El USUARIO reconoce y acepta que SURA TECH no
    rechaza solicitudes en materia de seguros, ni cubre directa o indirectamente
    ningún riesgo, ni se encuentra facultada para ello, ni para suscribir o
    modificar pólizas de seguros. SURA TECH facilita y habilita las herramientas
    tecnológicas para dichas gestiones entre el USUARIO y las ASEGURADORAS.<br /><br />

    <strong>Cotización</strong> <br />
    Las cotizaciones que SURA TECH facilita tienen una vigencia, condiciones y
    coberturas que pueden variar de una ASEGURADORA a otra. SURA TECH no se hace
    responsable en ningún caso por que las condiciones y coberturas sean iguales
    entre ASEGURADORAS. El período de vigencia de las cotizaciones que SURA TECH
    facilita al USUARIO podrán variar de acuerdo con lo establecido por cada
    ASEGURADORA.<br />
    El USUARIO acepta y comprende que la entrega de una tarifa y condiciones de
    cotización no implica la aceptación del riesgo por parte de la ASEGURADORA
    ni que SURA TECH garantice que dicha ASEGURADORA está dispuesta a aceptar el
    riesgo en las condiciones establecidas. Las ASEGURADORAS pueden aceptar o
    rechazar riesgos incluso después de haber entregado una cotización. Ni SURA
    TECH ni la ASEGURADORA tendrán responsabilidad ni obligación alguna con el
    USUARIO en los casos en que la ASEGURADORA rechace la aceptación del riesgo
    o modifique las condiciones o tarifas que entregó en su cotización.<br /><br />

    <strong>Información de la póliza</strong> <br />
    El USUARIO deberá cerciorarse que la información para contratar la póliza y
    al momento de la emisión de ésta, es correcta, exacta, veraz y está
    actualizada y concuerda con las condiciones y coberturas que es su deseo
    contratar. Al momento de contratar la póliza y en el momento de emisión de
    la misma el USUARIO deberá validar que la información que aparece en la
    carátula de la póliza es correcta, exacta y veraz. En caso de no ser así, el
    USUARIO deberá reportarlo a SURA TECH para subsanar y corregir su
    información o póliza en la mayor brevedad posible. Ni SURA TECH ni las
    ASEGURADORAS serán responsables de ningún daño, perjuicio o pérdida que
    resulte de la información incorrecta, inexacta o false en las carátulas de
    las pólizas y que el USUARIO así haya reportado en tiempo y forma.<br />
    El USUARIO acepta que las modificaciones que se realicen a la póliza o a las
    condiciones de contratación que modifiquen la clasificación o nivel del
    riesgo del seguro según los criterios de la ASEGURADORA, pueden modificar
    los montos pagaderos o requerir de un pago único del USUARIO a la
    ASEGURADORA con el fin de cubrir la diferencia entre el nuevo monto de las
    primas y el monto calculado anteriormente.<br /><br />

    <strong>Emisión</strong> <br />
    Para la emisión de las pólizas, SURA TECH podrá requerir información
    personal y datos personales (sensibles o no) al USUARIO para poder proceder
    a la contratación de la(s) póliza(s). El USUARIO podrá consultar la Política
    de privacidad y Tratamiento de datos personales de la ASEGURADORA para más
    información sobre el tratamiento de esta información y solicitar cualquier
    acción sobre su información según los mecanismos, formatos y procedimientos
    establecidos en la misma.<br /><br />

    <strong>Pagos</strong> <br />
    El USUARIO reconoce y acepta que cualquier cantidad monetaria que se destine
    para el pago de primas se realiza bajo su autorización expresa o que tiene
    la autorización expresa del propietario del recurso y garantiza que su
    proveniencia es de origen lícito, en los términos establecidos por la
    legislación vigente. Ni SURA TECH ni las ASEGURADORAS se harán responsables
    en ningún caso y por ningún motivo de cargos realizados a tarjetas con
    datos, documentos o tarjetas robados, hurtados, extraviados o duplicados.<br />

    El USUARIO entiende que el uso de los servicios ofrecidos por SURA TECH
    puede derivar en cargos o cobros en relación con la ASEGURADORA, en una
    única vez o recurrente, por: (I) los productos que contrate con una o varias
    ASEGURADORAS, (II) modificaciones a las condiciones de los productos
    contratados, (III) la declaración de un siniestro cuando las condiciones de
    la cobertura así lo especifiquen, (IV) u otros cargos que establezcan las
    ASEGURADORAS y que no dependan de SURA TECH.<br />
    La entrega de la carátula de póliza podrá verse afectada por el proceso de
    cobro de cada ASEGURADORA, SURA TECH no podrá modificar dicho proceso y
    tanto el USUARIO como SURA TECH deberán respetar los procedimientos,
    políticas y condiciones establecidos por cada ASEGURADORA para el pago de
    sus primas. SURA TECH no se hará responsable de ningún procedimiento,
    política o condiciones relativas o en relación con los cobros que realiza la
    ASEGURADORA, aun cuando SURA TECH haya sido informada de dicha situación y
    no haya sido corregida o subsanada.<br /><br />

    <strong>Modificaciones</strong> <br />
    En caso de solicitar modificaciones a las condiciones de contratación, el
    USUARIO acepta que la ASEGURADORA podrá aplicar cargos adicionales o reducir
    o aumentar el monto de cargos venideros, según sea el caso. Las
    modificaciones a las condiciones de contratación o endosos se realizan a
    discreción de la ASEGURADORA correspondiente y únicamente la ASEGURADORA
    tiene el derecho más no la obligación de aceptar o rechazar dichas
    solicitudes de modificación o endosos. Ni SURA TECH ni la ASEGURADORA serán
    responsables de ninguna solicitud de modificación o endoso rechazado por la
    ASEGURADORA, ni de ninguna modificación realizada de forma errónea,
    incorrecta o inexacta por la ASEGURADORA o SURA TECH que no haya sido
    debidamente reportada por el USUARIO, ni de la afectación, daño, perjuicio o
    pérdida en que el USUARIO o cualquier tercero puedan incurrir por una
    solicitud de modificación o endoso pendiente de ser realizado por la
    ASEGURADO o por SURA TECH.<br /><br />

    <strong>Responsabilidad</strong> <br />
    SURA TECH presta los servicios y habilita la tecnología para colocar los
    productos de seguros de las ASEGURADORAS, lo que implica que SURA TECH no
    asume responsabilidades como intermediario, no rechaza solicitudes en
    materia de seguros, no cubre directa o indirectamente ningún riesgo y no se
    encuentra facultada para hacerlo, no suscribe ni modifica pólizas de
    seguros.<br />

    La relación de seguro que se genera a partir del uso de la página web o
    aplicación móvil es directamente con la ASEGURADORA y no con SURA TECH.<br />
    SURA TECH facilita y habilita las herramientas tecnológicas para facilitar
    las gestiones antes descritas entre el USUARIO y las ASEGURADORAS.<br /><br />

    <strong
      >Prevención del lavado de activos y financiación del terrorismo</strong
    >
    <br />
    El USUARIO declara y garantiza que sus ingresos no provienen de actividades
    ilícitas y que no presentan registros negativos en listados de prevención de
    lavado de activos nacionales o internacionales, ni de financiación del
    terrorismo, narcotráfico, captación ilegal de dinero y en general cualquier
    actividad ilícita; de igual manera manifiestan que los ingresos que se
    generen durante la vigencia de los presentes T&C no se destinarán a ninguna
    de las actividades anteriormente descritas.<br />
    En consecuencia, será justa causa para dar por terminada la relación con el
    USUARIO, la inclusión de estos, de sus asociados, o de sus representantes en
    los listados de la OFAC, o de cualquier autoridad local o extranjera, como
    sospechoso de incurrir en cualquiera de dichas actividades.<br />
    El USUARIO expresa e irrevocablemente, autoriza a SURA TECH y a las
    ASEGURADORAS (directamente o a través de un tercero), para que consulte los
    listados, sistemas de información y bases de datos a que haya lugar y
    efectúe los reportes a las autoridades competentes en materia de lavado de
    activos y financiación al terrorismo, que considere necesarios para
    garantizar la prevención y/o administración del riesgo de lavado de activos
    y financiación al terrorismo.<br /><br />

    <strong>Contacto y notificaciones</strong> <br />
    SURA TECH podrá realizar notificaciones por medio de la página web o la
    aplicación de los servicios, mediante el correo electrónico y teléfono
    proporcionado por el USUARIO, según el caso.<br /><br />

    <strong>Ley aplicable</strong> <br />
    La ley aplicable a los presentes T&C será la colombiana en lo relativo a los
    servicios prestados por SURA TECH.<br /><br />

    <strong>Resolución de controversias</strong> <br />
    Cualquier controversia que surja de lo establecido en los presentes T&C en
    lo relativo a los servicios prestados por SURA TECH será resuelta mediante
    un acercamiento amistoso. En caso de no lograrse acuerdo alguno, ambas
    partes podrán acudir a los tribunales de la República de Colombia.<br /><br />
  </div>
  <br />
</div>
